export default __webpack_public_path__ + "static/media/icon-brand-bkash.280f4f83.svg";